import React, { Component } from "react";

class Units extends Component {
  DISABLE_MINDIGITS = -1;

  constructor(props) {
    super(props);
      this.state = { price: 0, btcAmt: 0, btcAmtStr: "", mbtcAmt: 0, mbtcAmtStr: "", satAmt: 0, satAmtStr: "", usd: 0, usdStr: "" };
  }

  async componentDidMount() {
    await this.timeout(1000);
    this.fetchPrice();
  }

  timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
  }

  fetchPrice() {
    fetch("stats/btcprice")
      .then((resp) => resp.text())
      .then((data) => {
          var prc = parseFloat(data);
          this.setState({
          price: prc,
          btcAmt: 0,
          btcAmtStr: "",
          mbtcAmt: 0,
          mbtcAmtStr: "",
          satAmt: 0,
          satAmtStr: "",
          usd: 0,
          usdStr: "",
        });
      });
  }

  getFormatter(minDigits) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: minDigits,
    });
  }

  setSatoshi(strSats) {
    if (strSats === "") {
      this.clearState();
      return;
    }

    if (strSats.endsWith(".")) return;

    var satsStr = strSats;
    var sats = parseFloat(strSats);
    if (isNaN(sats)) {
      return;
    }

    var btc = sats * 0.00000001;
    var btcStr = btc.toFixed(8);
    var mbtc = btc * 1000;
    var mbtcStr = mbtc.toFixed(5);
    var usd = this.state.price * btc;

    this.changeState(btc, btcStr, mbtc, mbtcStr, sats, satsStr, usd, null, 4);
  }

  setmBTC(strmBTC) {
    if (strmBTC === "") {
      this.clearState();
      return;
    }

    var mbtcStr = strmBTC;
    var mbtc = parseFloat(strmBTC);
    if (isNaN(mbtc)) {
      return;
    }

    var btc = mbtc * 0.001;
    var btcStr = btc.toFixed(8);
    var sats = Math.trunc(btc * 100000000);
    var satsStr = sats.toFixed(0);
    var usd = this.state.price * btc;

    this.changeState(btc, btcStr, mbtc, mbtcStr, sats, satsStr, usd, null, 2);
  }

  setBTC(strBTC) {
    if (strBTC === "") {
      this.clearState();
      return;
    }

    var btcStr = strBTC;
    var btc = parseFloat(strBTC);
    if (isNaN(btc)) {
      return;
    }

    var mbtc = btc * 1000;
    var mbtcStr = mbtc.toFixed(5);
    var sats = Math.trunc(btc * 100000000);
    var satsStr = sats.toFixed(0);
    var usd = this.state.price * btc;
    this.changeState(btc, btcStr, mbtc, mbtcStr, sats, satsStr, usd, null, 0);
  }

  setUSD(strUSD) {
    if (strUSD === "") {
      this.clearState();
      return;
    }

    var usd = parseFloat(strUSD);
    if (isNaN(usd)) {
      return;
    }

    var btc = usd / this.state.price;
    var btcStr = btc.toFixed(8);
    var mbtc = btc * 1000;
    var mbtcStr = mbtc.toFixed(5);
    var sats = Math.trunc(btc * 100000000);
    var satsStr = sats.toFixed(0);
    this.changeState(btc, btcStr, mbtc, mbtcStr, sats, satsStr, usd, strUSD, this.DISABLE_MINDIGITS);
  }

  changeState(btc, btcStr, mbtc, mbtcStr, sats, satsStr, usd, usdStr, minDigits) {
    var strUSD = "";
    if (minDigits === this.DISABLE_MINDIGITS) {
      strUSD = usdStr;
    }
    else {
      strUSD = this.getFormatter(minDigits).format(usd);
    }

    this.setState({
      price: this.state.price,
      btcAmt: btc,
      btcAmtStr: btcStr,
      mbtcAmt: mbtc,
      mbtcAmtStr: mbtcStr,
      satAmt: sats,
      satAmtStr: satsStr,
      usd: usd,
      usdStr: strUSD
    });
  }

  clearState() {
    this.changeState(0, "", 0, "", 0, "", 0, "", 4);
  }

  render() {
    return (
      <div className="times mbox">
        <h4 className="text-center" title="Convert Bitcoin units (sats/mBTC/BTC) to USD and vice versa. Enter your amount in left or right textbox.">
          <i className="bi bi-box-arrow-right" style={{ color: "brown" }}></i>{" "}
          BTC to USD
        </h4>
        <div style={{ textAlign: "center" }}>
            Convert BTC to USD and vice versa.  
        </div>
        {this.state.price > 0 && (
          <div>
            Exchange Rate: {this.getFormatter(0).format(this.state.price)}
          </div>
        )}
        <hr />
        <table>
        <tbody>
          <tr>
            <td width="350px">
              <table width="100%">
                <tbody>
                <tr style={{ height: 35 }}>
                  <td>
                    <div>
                      <input
                        name="unit1"
                        id="unit1"
                        type="text"
                        size="10"
                        value={this.state.satAmtStr}
                        onChange={(e) => {
                          this.setSatoshi(e.target.value);
                        }}
                      />
                      <span> Sats</span>
                    </div>
                  </td>
                </tr>
                <tr style={{ height: 35 }}>
                  <td>
                    <div>
                      <input
                        name="unit2"
                        id="unit2"
                        type="text"
                        size="10"
                        value={this.state.mbtcAmtStr}
                        onChange={(e) => {
                          this.setmBTC(e.target.value);
                        }}
                      />
                      <span> mBTC</span>
                    </div>
                  </td>
                </tr>
                <tr style={{ height: 35 }}>
                  <td>
                    <div>
                      <input
                        name="unit3"
                        id="unit3"
                        type="text"
                        size="10"
                        value={this.state.btcAmtStr}
                        onChange={(e) => {
                          this.setBTC(e.target.value);
                        }}
                      />
                      <span> BTC</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </td>
            <td width="20px">
              <div className="m-1">
                <i className="bi bi-arrow-left-right"></i>
              </div>
            </td>
            <td width="350px">
              <div>
                <input
                  name="usd"
                  id="usd"
                  type="text"
                  size="10"
                  style={{ textAlign: "right" }}
                  value={this.state.usdStr}
                  onChange={(e) => {
                    this.setUSD(e.target.value);
                  }}
                />
                <span> USD</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Units;
